import { defineMessages } from 'react-intl'

const messages = defineMessages({
  errorMessage: {
    id: 'SlackIntegrationSection.errorMessage',
    defaultMessage: 'Failed to load Slack integration configuration',
  },
  addToSlackButton: {
    id: 'SlackIntegrationSection.addToSlackButton',
    defaultMessage: 'Add to Slack',
  },
  notConnectedDescription: {
    id: 'SlackIntegrationSection.notConnectedDescription',
    defaultMessage:
      'Integrate Procurify Bot into your Slack team to get real-time notifications about:',
  },
  notConnectedBulletApprovalStatus: {
    id: 'SlackIntegrationSection.notConnectedBulletApprovalStatus',
    defaultMessage:
      'Order, Travel and Expense Requests being <strong>Approved</strong> or <strong>Denied</strong>',
  },
  notConnectedBulletPendingApproval: {
    id: 'SlackIntegrationSection.notConnectedBulletPendingApproval',
    defaultMessage: 'Requests created that need your <strong>Approval</strong>',
  },
  learnHowLinkText: {
    id: `SlackIntegrationSection.learnHowLinkText`,
    defaultMessage: 'Learn how to set up Slack',
  },
  disconnect: {
    id: `SlackIntegrationSection.disconnect`,
    defaultMessage: 'Disconnect',
  },
})

export default messages
